/**
 * @file Input component for text input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputStringBase } from '../../../base/helpers/input-string-base';
/**
 * Class for the text input component
 */
var InputTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputTextComponent, _super);
    function InputTextComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._mode = 'edit';
        /**
         * Get, sets a boolean flag to force the markdown component (version 2.2.3) to refresh itself
         * when the stringValue has changed. A work around solution for a markdown bug.
         */
        _this.forceRefresh = false;
        return _this;
    }
    Object.defineProperty(InputTextComponent.prototype, "mode", {
        /**
         * Get the mode of the text input
         */
        get: function () {
            return this._mode;
        },
        /**
         * Set the mode of the text input
         * @param mode The new mode to set
         */
        set: function (mode) {
            this._mode = mode;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Check if text input is in given mode
     * @param mode The mode
     */
    InputTextComponent.prototype.inMode = function (mode) {
        return (mode === this._mode);
    };
    /**
     * Set the value of the input.
     * We override this method to force a refresh of the markdown component (version 2.2.3).
     * @protected
     * @param {*} val The new val to set.
     */
    InputTextComponent.prototype.setValue = function (val) {
        var _this = this;
        if ((this.readOnly || this.inMode('preview')) && this.value !== val) {
            window.setTimeout(function () {
                _this.forceRefresh = true;
                window.setTimeout(function () {
                    _this.forceRefresh = false;
                });
            });
        }
        _super.prototype.setValue.call(this, val);
    };
    /**
     * Gets the displayed value.
     * Override needed for Edge, null to string becomes "null" instead of "".
     * @protected
     * @returns {*} String value
     * @memberOf InputTextComponent
     */
    InputTextComponent.prototype.getValue = function () {
        var test = _super.prototype.getValue.call(this);
        return test == null ? '' : test; // Fix issue: Edge en IE: 'null' in notitievak ruiloverlay #3567
    };
    return InputTextComponent;
}(InputStringBase));
export { InputTextComponent };
